<script setup lang="ts">
  import Typography from '../Typography/Typography.vue'
  import type { Variant, Weight } from '../Typography/Typography.vue'
  export interface ButtonProps {
    size?: 'small' | 'default' | 'large'
    labelFontVariant?: Variant
    labelFontWeight?: Weight
    labelColor?: string
    rounded?: boolean
  }
  withDefaults(defineProps<ButtonProps>(), {
    size: 'default',
    labelFontVariant: 'text-base',
    labelFontWeight: 'font-semibold',
    labelColor: 'text-content-inverted-primary',
    rounded: false,
  })
</script>
<template>
  <button
    class="flex items-center justify-center self-stretch rounded-lg bg-action-primary-default hover:bg-action-primary-hover active:bg-action-primary-active"
    :class="[
      {
        'px-3 py-1.5': size === 'small',
        'px-3 py-2': size === 'default',
        'p-3': size === 'large',
        '!rounded-3xl': rounded,
      },
    ]"
  >
    <Typography
      :variant="labelFontVariant"
      :weight="labelFontWeight"
      :color="labelColor"
    >
      <slot />
    </Typography>
  </button>
</template>
